// import ApiServices from "@/services/ApiServices";
//import { mapState } from "vuex";

export default {
  data: () => ({
    clsById: null,
    companiesForCLlist: null,
  }),
  computed: {
    // ...mapState(["allClData"]),
    //...mapState(["clMetadata"]),
    allLensIds: function () {
      return this.clsById ? Object.keys(this.clsById) : null;
    },
    alphabeticalCompanies: function () {},
    lensesByCompany: function () {},
  },
  methods: {
    // where param is "types" or "replaces" (matches key in clMetadata)
    // and val is like "BIFOCAL_SPHERE" (types) or "14" (replaces)
    lensIdsForParameter: function (param, val) {
      console.log("lensIdsForParameter()");
      if (!this.clMetadata || !this.allClData) return null;
      let ids = this.clMetadata[param][val];
      if (!ids) return null;
      let filteredIds = this.allLensIds.filter((value) => ids.includes(value));
      return filteredIds;
    },

    lensArrayForIds: function (idArr) {
      if (!this.allClData) return null;
      let lensArr = [];
      idArr.forEach((id) => {
        console.log("id " + id);
        lensArr.push(this.allClData[id]);
      });
      return lensArr;
    },
    filterForCompanyIdArr: function (lensArr, companyIdArr = null) {
      if (!companyIdArr) companyIdArr = ["1", "2", "4", "8"];
      let filteredLenses = lensArr.filter((lensObj) =>
        companyIdArr.includes(lensObj.company_id)
      );
      return filteredLenses;
    },
  },
  mounted: function () {},
};
